import React, { FunctionComponent } from 'react';
import ReCAPTCHA, { type ReCAPTCHAProps } from 'react-google-recaptcha';
import type { UnsubscribePageState } from './types';
import { SelectBox } from '../../atoms/selectBox';
import { TextArea } from '../../atoms/textArea';
import { FlashBox } from '../../atoms/flashBox';
import { Loading } from '../../atoms/loading';

type Props = {
  state: UnsubscribePageState;
  flash: boolean;
  flashType: string;
  flashMessage: string;
  currentUser: boolean;
  preferenceEditPath: string;
  onChangeForm: (name: string, value: string) => void;
  onSubmit: () => void;
  onRecaptcha: (token: string | null) => void;
  recaptchaSiteKey: string;
  handleFlash: (flash: boolean, flashType: string, flashMessage: string) => void;
};

export const Presentation: FunctionComponent<Props> = ({
  state,
  flash,
  flashType,
  flashMessage,
  currentUser,
  preferenceEditPath,
  onChangeForm,
  onSubmit,
  onRecaptcha,
  recaptchaSiteKey,
  handleFlash,
}) => {
  // `@types/react-google-recaptcha` の型が一部の React/TS 組み合わせで
  // JSX 要素として扱えなくなるため、コンポーネント型としてキャストします。
  const ReCAPTCHAWidget = ReCAPTCHA as unknown as React.ComponentType<ReCAPTCHAProps>;

  return (
    <div className="u-clear">
      <main className="l-main" style={{ width: '100%' }}>
        {state.isLoading && <div className="overall-loading"><Loading /></div>}
        <div className="contact">
          <div className="contact-content">
            <FlashBox
              flash={flash}
              flashType={flashType}
              flashMessage={flashMessage}
              handleFlash={handleFlash}
            />
            <div className="contact-title">アカウント退会</div>

            <div className="content-part">
              <div className="content-sub-title">メール通知が多すぎると感じている方</div>
              <div>
                {currentUser ? (
                  <p>
                    メールの配信を停止したい方は、「
                    <a href={preferenceEditPath} className="link">メール・スカウト設定</a>
                    」から変更してください。
                  </p>
                ) : (
                  <p>メールの配信を停止したい方は、ログイン後「メール・スカウト設定」から変更してください。</p>
                )}
              </div>
            </div>

            <div className="content-part">
              <div className="content-sub-title">企業の方</div>
              <div>
                <p>
                  お手数おかけしますが、「
                  <a href="/contact" className="link">お問い合わせ</a>
                  」からご連絡ください。
                </p>
              </div>
            </div>

            <div className="content-part">
              <div className="content-sub-title">アカウント退会に関して</div>
              <div>
                <p>ログイン後、こちらから退会処理を行うことができます。</p>
              </div>
            </div>

            <div className="contact-form">
              <SelectBox
                className="contact-form-category"
                placeholder="選択してください"
                options={{
                  '就職先が決まったため': '就職先が決まったため',
                  'その他': 'その他',
                }}
                onChanged={onChangeForm}
                name="reason"
                value={state.reason}
              />
              <TextArea
                className="contact-form-body"
                placeholder={'就職先が決まったため\n  就職・内定先：\n  上記企業をどちらでお知りになりましたか？：\n\nその他\n  理由をお聞かせください：'}
                onChanged={onChangeForm}
                name="body"
                value={state.body}
              />
              <ReCAPTCHAWidget
                sitekey={recaptchaSiteKey}
                onChange={onRecaptcha}
                hl="ja"
              />
              {currentUser ? (
                <button
                  type="button"
                  className={!state.recaptchaToken ? 'contact-form-button-disabled' : 'contact-form-button'}
                  onClick={onSubmit}
                  disabled={!state.recaptchaToken}
                >
                  アカウントを退会する
                </button>
              ) : (
                <p className="contact-form-button-disabled">ログインしてください</p>
              )}
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};
